/**
 * ============================================================================
 *   Copyright (c) 2026 Dobler Data Solutions, LLC. ALL RIGHTS RESERVED.
 * ============================================================================
 *   Module       : lastCollectedAt
 *   Feature      : 226-universal-page-affordances (owner decision 11, T038)
 *   Description  : The time behind a dashboard's "collected X ago": the newest
 *                  collection run that collected something. collectionHealth
 *                  carries each tier's latest run from dbo.data_collection_runs
 *                  (which the worker lane writes); a tier whose latest run
 *                  failed contributes nothing rather than a time it did not earn.
 *   Author       : Peter Dobler
 *   Created      : 2026-10-29
 * ============================================================================
 */
import type { DashboardKpis } from '../../../shared/types/dashboard';

export function lastCollectedAt(health: DashboardKpis['collectionHealth'] | undefined): number | undefined {
  let newest: number | undefined;
  for (const tier of health?.tiers ?? []) {
    if (tier.lastStatus !== 'Completed' && tier.lastStatus !== 'Partial') continue;
    const at = tier.lastRunAt ? Date.parse(tier.lastRunAt) : Number.NaN;
    if (Number.isFinite(at) && (newest === undefined || at > newest)) newest = at;
  }
  return newest;
}
